var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttemptCoin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4671 0H23.5327V48H28.4671C41.465 48 51.9999 37.2545 51.9999 24C51.9999 10.7455 41.465 0 28.4671 0Z",
    fill: "#C76216"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5327 46.6978V47.9997H28.4671C33.988 47.9997 39.062 46.0552 43.0768 42.8086L23.5343 42.993V46.6978H23.5327Z",
    fill: "#DBA97F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9573 16.406L50.7458 16.2677C49.6361 12.9415 47.8326 9.94644 45.5076 7.45703L33.8533 7.55342L33.9573 16.406Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8515 5.86705L43.7819 5.78603C43.2734 5.3404 42.7469 4.91711 42.201 4.51758L33.8352 4.58603L33.8498 5.86705H33.8515Z",
    fill: "white",
    fillOpacity: 0.68
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5328 48C36.5296 48 47.0656 37.2548 47.0656 24C47.0656 10.7452 36.5296 0 23.5328 0C10.536 0 0 10.7452 0 24C0 37.2548 10.536 48 23.5328 48Z",
    fill: "#FDCAA4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5328 47.2123C36.1034 47.2123 46.2939 36.8199 46.2939 24.0002C46.2939 11.1805 36.1034 0.788086 23.5328 0.788086C10.9622 0.788086 0.771729 11.1805 0.771729 24.0002C0.771729 36.8199 10.9622 47.2123 23.5328 47.2123Z",
    fill: "#FBAF77"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2636 44.1625L45.0461 16.4214C43.9315 13.133 42.1167 10.1798 39.7787 7.74902L4.87427 37.2852C6.80447 40.0987 9.3277 42.454 12.2636 44.1625Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5044 30.0615L25.3315 47.1325C35.0427 46.3572 43.0413 39.371 45.5044 30.0615Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78385 17.1422L20.925 0.944336C18.6292 1.21116 16.4374 1.82722 14.4016 2.73805L4.72789 10.9243C3.46059 12.8158 2.45975 14.9071 1.78223 17.1436L1.78385 17.1422Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61013 35.2231L38.0239 6.1004C37.6096 5.75115 37.179 5.42147 36.7403 5.10156L2.88062 33.7549C3.10808 34.2536 3.35017 34.7439 3.61013 35.2231Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5328 0.877299C36.3862 0.877299 46.8252 11.3867 47.0559 24.4387C47.0591 24.292 47.0673 24.1467 47.0673 24C47.0673 10.7455 36.5308 0 23.5328 0C10.5349 0 0 10.7455 0 24C0 24.1467 0.00812373 24.292 0.0113732 24.4387C0.242087 11.3867 10.6811 0.877299 23.5328 0.877299Z",
    fill: "white",
    fillOpacity: 0.68
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0576 41.1603C32.9985 41.1603 40.2466 33.7682 40.2466 24.6495C40.2466 15.5308 32.9985 8.13867 24.0576 8.13867C15.1167 8.13867 7.86865 15.5308 7.86865 24.6495C7.86865 33.7682 15.1167 41.1603 24.0576 41.1603Z",
    fill: "white",
    fillOpacity: 0.68
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5327 40.5109C32.4736 40.5109 39.7217 33.1188 39.7217 24.0001C39.7217 14.8814 32.4736 7.48926 23.5327 7.48926C14.5918 7.48926 7.34375 14.8814 7.34375 24.0001C7.34375 33.1188 14.5918 40.5109 23.5327 40.5109Z",
    fill: "#FA9549"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4462 33.8195C23.9889 33.8195 21.5317 33.8265 19.0744 33.8148C18.6825 33.8148 18.1333 33.9826 18.1333 33.2929C18.1333 32.6032 18.6801 32.7849 19.0744 32.7663C19.5063 32.7453 19.9803 32.8222 19.9404 32.1535C19.9193 31.7947 20.1423 31.6875 20.4568 31.6921C20.8065 31.6968 21.1186 31.6013 21.0646 31.1865C20.9332 30.1636 21.5786 30.1962 22.2944 30.2009C25.1037 30.2195 27.913 30.2195 30.7199 30.2009C31.3583 30.1962 31.8089 30.2894 31.7174 31.07C31.6657 31.515 31.9004 31.7014 32.3393 31.6921C32.574 31.6875 32.8697 31.7108 32.8627 32.0114C32.8439 32.8712 33.44 32.764 33.9822 32.7593C34.3624 32.757 34.6886 32.7966 34.6722 33.3069C34.6534 33.8218 34.3014 33.8195 33.9376 33.8195C31.4404 33.8195 28.9433 33.8195 26.4485 33.8195H26.4462Z",
    fill: "#FFDFB9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3187 22.6642C24.5186 20.8794 22.7161 19.0945 20.916 17.3097C21.8055 15.5108 23.3592 14.3667 24.9621 13.2739C26.7693 15.0658 28.5764 16.8576 30.3836 18.6518C30.4211 19.0339 30.2592 19.3368 29.9729 19.5629C29.0881 20.2642 28.3535 21.1124 27.5672 21.9116C27.234 22.2518 26.9054 22.6968 26.3187 22.6642Z",
    fill: "#FFDFB9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5493 21.108C23.5845 21.6719 23.3404 21.835 23.1574 22.0261C20.2307 25.0855 17.29 28.1333 14.3868 31.2137C13.9268 31.703 13.6288 31.7682 13.2063 31.2346C12.9928 30.962 12.7299 30.7174 12.4553 30.503C11.892 30.0673 11.8897 29.7131 12.4342 29.2145C15.5322 26.3834 18.6019 23.5244 21.6882 20.6793C21.9276 20.4579 22.1552 20.0269 22.5518 20.2669C22.9743 20.5232 23.3146 20.9053 23.5493 21.108Z",
    fill: "#FFDFB9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9622 13.274C23.3592 14.3692 21.8055 15.5133 20.916 17.3098C20.0969 17.3005 19.0784 17.9739 18.5996 16.7482C18.1842 15.6857 19.1816 15.2663 19.7238 14.6884C20.6766 13.6725 21.6999 12.7218 22.6833 11.7339C23.1527 11.2632 23.6713 10.916 24.3308 11.2841C24.9692 11.643 25.2391 12.1952 24.9269 12.9315C24.8871 13.0247 24.9481 13.1575 24.9645 13.2717L24.9622 13.274Z",
    fill: "#FFDFB9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3186 22.6645C26.9054 22.6971 27.2316 22.2521 27.5672 21.9119C28.3534 21.1103 29.088 20.2645 29.9728 19.5632C30.2591 19.3371 30.4211 19.0342 30.3835 18.6521C31.1369 18.7523 32.0991 18.3002 32.5239 19.3115C32.9698 20.374 31.9935 20.8121 31.4396 21.3946C30.4774 22.4059 29.4612 23.3635 28.4731 24.3515C27.992 24.8338 27.532 25.2952 26.7669 24.8292C26.0464 24.3911 26.0558 23.8063 26.3069 23.1259C26.3562 22.9884 26.3186 22.8206 26.321 22.6668L26.3186 22.6645Z",
    fill: "#FFDFB9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42746 25.3985C8.42746 16.2804 15.6754 8.88763 24.6164 8.88763C29.4517 8.88763 33.7881 11.0515 36.7549 14.4783C33.8222 10.2511 28.9951 7.48926 23.5327 7.48926C14.5917 7.48926 7.34375 14.882 7.34375 24.0001C7.34375 28.1882 8.87589 32.0089 11.3942 34.9188C9.52741 32.2283 8.42746 28.944 8.42746 25.3971V25.3985Z",
    fill: "#F97A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptCoin);
export default __webpack_public_path__ + "static/media/attempt-coin.fb42181db67a71ba0540f11b37545cb2.svg";
export { ForwardRef as ReactComponent };